<template>
  <div class="cs-overlay">
    <div class="cs-overlay__content">
      <div class="cs-overlay__logo">
        <Logo size="60" color="primary" only-mark />
      </div>
      <VText class="cs-overlay__title" component="h1" variant="h3"
        >This account has been suspended for violating our community
        standards.</VText
      >

      <div class="cs-overlay__actions">
        <InlineLink href="https://campsite.bio">
          Return to homepage
        </InlineLink>
      </div>
    </div>
  </div>
</template>

<script>
import {
  VText,
  InlineLink,
  Logo,
  defaultWindow,
} from '@campsite-bio/component-lib';
import { onMounted } from '@nuxtjs/composition-api';

export default {
  components: {
    VText,
    Logo,
    InlineLink,
  },

  setup() {
    onMounted(() => {
      if (defaultWindow) {
        const tomorrow = new Date();
        tomorrow.setHours(tomorrow.getHours() + 1);
        document.cookie = `visited_spam=true;domain=${
          location.hostname
        };expires=${tomorrow.toUTCString()};secure`;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.cs-overlay {
  background: var(--g-color-bg);
  color: var(--g-color-on-bg);
  font: 400 18px/1.4 var(--g-font-body-family);
  display: flex;
  height: 100vh;
  place-content: center space-between;
  flex-direction: column;
  margin-left: -0.925rem;
  margin-right: -0.925rem;
  padding: 2.5rem 0.925rem;
  text-align: center;
  align-items: center;

  &__content {
    margin-top: 5rem;
    max-width: 600px;
    width: 92%;
  }

  &__logo {
    margin-bottom: 1.5rem;
  }

  &__actions {
    font-size: 1rem;
    margin-top: 2rem;
  }
}

.cs-overlay__title.cs-overlay__title {
  margin-bottom: 1rem;
}
</style>
